import LTR from "@brand-icons/ploom/long-arrow-backward/long-arrow-backward-ltr.svg";
import RTL from "@brand-icons/ploom/long-arrow-backward/long-arrow-backward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const LongArrowBackwardIcon = iconFactory("LongArrowBackwardIcon", LTR, RTL);
